import React, { useState } from 'react';
import {
    TextField,
    Button,
    Typography,
    Card,
    CardContent,
    Box
} from '@mui/material';
import { toast } from 'react-toastify';
import { auth, db } from '../../firebase';
import { setDoc, doc } from 'firebase/firestore';
import { createUserWithEmailAndPassword } from 'firebase/auth';


const Register = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleRegister = async () => {
        if (!name || !email || !password || !confirmPassword) {
            toast.error('Please fill in all fields');
            return;
        }

        if (password !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }

        try {
            await createUserWithEmailAndPassword(auth, email, password);
            const user = auth.currentUser;
            if (user) {
                await setDoc(doc(db, "users", user.uid), {
                    email: user.email,
                    password: password,
                    name: name,
                    uid: user.uid,
                    role: 'Superadmin',
                });
            }
            toast.success(`Welcome ${name}! Your account has been created.`);
            window.location.href = "/home"

        } catch (error) {
            toast.error(`Somethin was wrong,   ${error}!`);
            console.log(error);
            
            // TODO: Add Firebase or API registration logic here
        };
    }


    return (
        <div
            className="d-flex justify-content-center align-items-center vh-100"
            style={{
                backgroundImage: 'url("/background.jpg")',
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >
            <Card
                sx={{
                    maxWidth: 450,
                    width: '100%',
                    boxShadow: 6,
                    borderRadius: 3,
                    backgroundColor: '#fff'
                }}
            >
                <CardContent>
                    <Box display="flex" justifyContent="center" mb={2}>
                        <img src="/logo.png" alt="Logo" style={{ height: '80px' }} />
                    </Box>

                    <Typography
                        variant="h5"
                        align="center"
                        gutterBottom
                        color="primary"
                    >
                        <b>Register for ViperX Education</b>
                    </Typography>

                    <TextField
                        label="Full Name"
                        variant="outlined"
                        fullWidth
                        size="small"
                        margin="normal"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />

                    <TextField
                        label="Email Address"
                        variant="outlined"
                        fullWidth
                        size="small"
                        margin="normal"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <TextField
                        label="Password"
                        type="password"
                        variant="outlined"
                        fullWidth
                        size="small"
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <TextField
                        label="Confirm Password"
                        type="password"
                        variant="outlined"
                        fullWidth
                        size="small"
                        margin="normal"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />

                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 2 }}
                        onClick={handleRegister}
                    >
                        Register
                    </Button>

                    <Typography variant="body2" align="center" sx={{ mt: 2 }}>
                        Already have an account?{' '}
                        <a href="/login" className="text-primary">
                            Login
                        </a>
                    </Typography>
                </CardContent>
            </Card>
        </div>
    );
};

export default Register;
